function getRandomColors() {
  // 随机生成 RGB 值
  let r = Math.floor(Math.random() * 256);
  let g = Math.floor(Math.random() * 256);
  let b = Math.floor(Math.random() * 256);

  // 将 RGB 值转换为十六进制格式
  let hex = "#" + r.toString(16) + g.toString(16) + b.toString(16);

  return hex;
}
function getRandomColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}
let addColor=[]
for (let i=0;i<1000;i++){
  addColor.push(getRandomColor())
}
export const defaultColor = ["#B2182B","#56B4E9","#E69F00","#009E73","#F0E442","#0072B2",
  "#D55E00","#CC79A7","#CC6666","#9999CC","#66CC99","#999999",
  "#ADD1E5"].concat(addColor)
